module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226204437_07_pre#pre"
    }
  }, [_vm._v("Prefatory Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226204437_08_int#int"
    }
  }, [_c('strong', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocab"
  }, [_vm._v("Charles R. Hulten and Marshall B. Reinsdorf")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226204437_09_pt1#pt1"
    }
  }, [_vm._v("I. ADVANCING ECONOMIC AND FINANCIAL MEASUREMENT PRACTICE: LESSONS FROM THE FINANCIAL CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226204437_10_ch1#ch1"
    }
  }, [_c('strong', [_vm._v("1. Integrating the Economic Accounts: Lessons from the Crisis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Barry Bosworth")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/9780226204437_11_ch2#ch2"
    }
  }, [_c('strong', [_vm._v("2. Financial Statistics for the United States and the Crisis: What Did They Get Right, What Did They Miss, and How Could They Change?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Matthew J. Eichner, Donald L. Kohn, and Michael G. Palumbo")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_12_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. Durable Financial Regulation: Monitoring Financial Instruments as a Counterpart to Regulating Financial Institutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Leonard Nakamura")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_13_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4. Shadow Banking and the Funding of the Nonfinancial Sector")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Joshua Gallin")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_14_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5. Financial Intermediation in the National Accounts: Asset Valuation, Intermediation, and Tobin’s "), _c('em', [_vm._v("q")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocab"
  }, [_vm._v("Carol A. Corrado and Charles R. Hulten")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_15_pt2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. ADVANCES IN MEASURING WEALTH AND FINANCIAL FLOWS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_16_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6. Adding Actuarial Estimates of Defined-Benefit Pension Plans to National Accounts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Dominque Durant, David Lenze, and Marshall B. Reinsdorf")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_17_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7. The Return on US Direct Investment at Home and Abroad")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Stephanie E. Curcuru and Charles P. Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_18_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8. US International Financial Flows and the US Net Investment Position: New Perspectives Arising from New International Standards")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocab"
  }, [_vm._v("Christopher A. Gohrband and Kristy L. Howell")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_19_pt3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. HOW DID THE FINANCIAL CRISIS AFFECT HOUSEHOLDS AND BUSINESSES?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_20_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9. Household Debt and Saving during the 2007 Recession")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Rajashri Chakrabarti, Donghoon Lee, Wilbert van der Klaauw, and Basit Zafar")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_21_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10. Drowning or Weathering the Storm? Changes in Family Finances from 2007 to 2009")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_vm._v("Jesse Bricker, Brian Bucks, Arthur Kennickell, Traci Mach, and Kevin Moore")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_22_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11. The Misfortune of Nonfinancial Firms in a Financial Crisis: Disentangling Finance and Demand Shocks")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocab"
  }, [_vm._v("Hui Tong and Shang-Jin Wei")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_23_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_24_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_25_aut#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226204437_26_sub#sub",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484c6c1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226204437_06_toc.vue
// module id = 72
// module chunks = 0